
// decoradores
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ItemTabla extends Vue {
  @Prop() readonly valor!: string;
  @Prop() readonly clases?: string;
}
